import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Collapse, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Input } from 'reactstrap';
import { BsTelephone } from "react-icons/bs";
import { PiClockBold } from "react-icons/pi";
import { SlLocationPin } from "react-icons/sl";
import { MdOutlineMail } from "react-icons/md";
import { Btn, H5, P } from '../../AbstractElements';
import { HelpCircle } from 'react-feather';
import { FaChevronDown } from "react-icons/fa6";
import { Cancel, Collection, Description, EditBookmark, General, Group, MyBookmarks, Save, Title, WebUrl } from '../../Constant';
import { useForm } from 'react-hook-form';
import { getHelpList } from '../../Apis/Setting';
import Loader from '../../Modules/Settings/Loader';



const faq = [
  {
    title: "How do I activate my GPS device?",
    para: "To activate your GPS device, follow these steps: 1. Power on the device 2. Connect to the mobile app 3. Enter the device ID 4. Follow the on-screen instructions"
  },
  {
    title: "What is the battery life of the device?",
    para: "The device battery typically lasts 5-7 days on a single charge with normal usage. Battery life may vary based on tracking frequency and signal strength."
  },
  {
    title: "How accurate is the GPS tracking?",
    para: "Our GPS devices provide accuracy within 5-10 meters in optimal conditions. Accuracy may be affected by weather, buildings, and satellite coverage."
  },
  {
    title: "What should I do if my device is offline?",
    para: "If your device goes offline: 1. Check the battery level 2. Ensure the device has network coverage 3. Restart the device 4. Contact support if the issue persists"
  },
];
const HelpCenter = () => {

  const [isActivity, setIsActivity] = useState({});
  const [HelpData, setHelpData] = useState([]);
  const [urls, setUrls] =  useState([]);
  const [loading, setloading] = useState(false);

  const handleChange = (index) => {
    setIsActivity((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

const fetchHelp = async () => {
  setloading(true)


    try {
      const helpData = await getHelpList();
      // console.log("helpData", helpData?.data);
      setHelpData(helpData?.data[0]);
      setUrls(helpData?.data[0]?.urls);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }finally {
    setloading(false)
    }
  };
  // setStatusListing(res.data);
  useEffect(() => {
    fetchHelp();
  }, []);
console.log("helpppDtaaaa", HelpData);
  return (
    <>
      <div className="product-container">
        <div className="container">
        {loading ? (
          <>
          <Loader />
          </>
        ) : (
          
          <div className="px-5 py-3">
            <h2 className="text-3xl font-bold mb-1">Help Center</h2>
            <p className="text-gray-600 text-sm">Find answers to common questions and learn how to use your GPS device</p>
            <div className='mt-4 row'>
              <div className='col-12 text-lg font-semibold mb-3'>{HelpData?.title}</div>
              {urls?.map((u, index) => {
  const embedUrl = u?.link.replace("watch?v=", "embed/").replace("&t=", "?start=");

  return (
    <div className='col-md-4 mb-3 mb-md-0' key={index}>
      <div className='custom-card p-4'>
        <h3 className='font-semibold tracking-tight text-lg mb-3'>{u?.title}</h3>
        <iframe
          className="w-100 cc-iframe"
          height="200px"
          src={embedUrl}
          title={u?.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <p className='mt-2 text-sm text-muted-foreground'>{u?.description}</p>
      </div>
    </div>
  );
})}

              {/* <div className='col-md-4 mb-3 mb-md-0'>
                <div className='custom-card p-4'>
                  <h3 className='font-semibold tracking-tight text-lg mb-3'>Advanced Features Tutorial</h3>
                  <iframe className="w-100 cc-iframe" height="200px" src="https://www.youtube.com/embed/example1" title="Quick Start Guide" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen=""></iframe>
                  <p className='mt-2 text-sm text-muted-foreground'>Detailed walkthrough of all device features</p>
                </div>
              </div> */}
           
            </div>
            <div className='mt-4'>
              <div className='text-lg font-semibold mb-3'>Frequently Asked Questions</div>
              <div className='custom-card p-4'>
                <div className="custom-according" id="accordionoc">
                  {faq?.map((item, index) => (
                    <Card key={index} className={isActivity[index] ? "active ms-0" : "ms-0"}>
                      <CardHeader>
                        <H5 attrH5={{ className: 'mb-0' }}>
                          <Btn className={`font-medium py-4`}
                            attrBtn={{ color: 'link', onClick: () => handleChange(index) }}
                          >
                            <div>
                              {item.title}
                            </div>
                            <FaChevronDown />
                          </Btn>
                        </H5>
                      </CardHeader>
                      <Collapse isOpen={isActivity[index]}>
                        <CardBody>
                          <P>{item.para}</P>
                        </CardBody>
                      </Collapse>
                    </Card>
                  ))}
                </div>
              </div>
            </div>

            <div className='mt-4 row'>
              <div className='col-12 text-lg font-semibold mb-3'>Contact Us</div>
              <div className='col-md-6 mb-3 mb-md-0'>
                <div className='custom-card p-4 h-100'>
                  <h3 className='font-semibold tracking-tight text-lg mb-3'>Support Hours</h3>
                  <div className="d-flex align-items-center gap-3">
                    <PiClockBold className='text-2xl' />
                    <div>
                      <p className="font-medium">Monday - Saturday</p>
                      <p className="text-sm text-muted-foreground">9:00 AM - 6:00 PM</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <BsTelephone className='text-2xl' />
                    <div>
                      <p className="font-medium">Support Hotline</p>
                      <p className="text-sm text-muted-foreground">+91 8306006901-02-03</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <MdOutlineMail className='text-2xl' />
                    <div>
                      <p className="font-medium">Email Support</p>
                      <p className="text-sm text-muted-foreground">support@raviens.com</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <SlLocationPin className='text-2xl' />
                    <div>
                      <p className="font-medium">Head Office</p>
                      <p className="text-sm text-muted-foreground">G 845 RIICO Industrial area sitapura jaipur, 302022</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6 mb-3 mb-md-0'>
                <div className='custom-card p-4 h-100'>
                  <h3 className='font-semibold tracking-tight text-lg mb-3'>Emergency Support</h3>
                  <p className='text-muted-foreground text-sm mb-2'>For urgent assistance outside of regular business hours, please contact our 24/7 emergency support line.</p>
                  <div className="d-flex align-items-center gap-3">
                    <BsTelephone className='text-lg text-danger' />
                    <div>
                      <p className="font-medium">Emergency Hotline</p>
                      <p className="text-sm text-muted-foreground">+91 8306006901-02-03</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
           )}
        </div>
        
       
        </div>
        </>
    
    
  )
}

export default HelpCenter